/**
 * Image and File Upload Limits
 * Centralized constants for upload validation across the application
 * MUST match backend limits in app/api/endpoints/change_requests.py
 */

export const IMAGE_LIMITS = {
  // Gallery Images - Max 6 images per company (matches backend validation)
  GALLERY_MAX: 6,

  // File Size Limits (in MB)
  LOGO_MAX_SIZE_MB: 5,
  GALLERY_MAX_SIZE_MB: 5,

  // Allowed Image Formats
  ALLOWED_FORMATS: ['image/jpeg', 'image/png', 'image/webp'] as const,

  // Accept string for file input
  ACCEPT_STRING: 'image/jpeg,image/png,image/webp',

  // Max file size in bytes
  MAX_FILE_SIZE_BYTES: 5 * 1024 * 1024, // 5MB
} as const;

/**
 * Error messages for image upload validation
 */
export const IMAGE_ERROR_MESSAGES = {
  GALLERY_MAX_EXCEEDED: (current: number, max: number = IMAGE_LIMITS.GALLERY_MAX) =>
    `สามารถอัปโหลดได้สูงสุด ${max} รูป (ปัจจุบันมี ${current} รูป)`,

  GALLERY_NO_SLOTS: (max: number = IMAGE_LIMITS.GALLERY_MAX) =>
    `คุณอัปโหลดรูปครบ ${max} รูปแล้ว กรุณาลบรูปเก่าก่อนเพิ่มรูปใหม่`,

  FILE_TOO_LARGE: (sizeMB: number = IMAGE_LIMITS.LOGO_MAX_SIZE_MB) =>
    `ขนาดไฟล์ต้องไม่เกิน ${sizeMB}MB`,

  INVALID_FORMAT: 'ประเภทไฟล์ไม่ถูกต้อง (รองรับเฉพาะ JPG, PNG, WebP)',

  BACKEND_REJECTION: 'รูปแกลเลอรี่เกินจำนวนที่กำหนด',
} as const;

/**
 * Helper function to check if upload is allowed
 */
export const canUploadMoreImages = (currentCount: number): boolean => {
  return currentCount < IMAGE_LIMITS.GALLERY_MAX;
};

/**
 * Helper function to calculate remaining slots
 */
export const getRemainingImageSlots = (currentCount: number): number => {
  return Math.max(0, IMAGE_LIMITS.GALLERY_MAX - currentCount);
};

/**
 * Helper function to validate file size
 */
export const isFileSizeValid = (fileSizeBytes: number): boolean => {
  return fileSizeBytes <= IMAGE_LIMITS.MAX_FILE_SIZE_BYTES;
};

/**
 * Helper function to validate file type
 */
export const isFileTypeValid = (fileType: string): boolean => {
  return IMAGE_LIMITS.ALLOWED_FORMATS.includes(fileType as any);
};
